import { render, staticRenderFns } from "./PopularNow.vue?vue&type=template&id=4b534f11&scoped=true&"
import script from "./PopularNow.vue?vue&type=script&lang=js&"
export * from "./PopularNow.vue?vue&type=script&lang=js&"
import style0 from "./PopularNow.vue?vue&type=style&index=0&id=4b534f11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b534f11",
  null
  
)

export default component.exports